import classNames from "classnames";
import { ComponentLoader } from "./Loader";
import styles from "./styles.module.scss";
import { useReactFlow } from "reactflow";
import { useLineageContext } from "../context/LineageProvider";
import { SnowflakeStageMetadata } from "../types";
import { getSnowflakeStageDetails } from "../api";
import { Stack } from "@altimateai/lego";
import { SeedIcon } from "../assets/icons";
import { Card, Typography } from "@altimateai/lego";
import { useQuery } from "../../api/index";
import { useCallback } from "react";

const SnowflakeStageDetails = () => {
  const flow = useReactFlow();
  const {
    state: { selectedTable },
  } = useLineageContext();
  const selectedTableData = flow.getNode(selectedTable)?.data;
  const fetchDetails = useCallback(() => getSnowflakeStageDetails(selectedTable), [selectedTable]);

  const { data, loading } = useQuery<SnowflakeStageMetadata>({
    queryFn: fetchDetails,
  });

  if (loading || !data || !selectedTable) return <ComponentLoader />;

  return (
    <Stack direction="column" className="al-p-2 al-h-full al-overflow-y">
      <div className={styles.table_details_header}>
        <Stack direction="column" align="center" gap="none" className="al-text-primary">
          <SeedIcon className="icon-sm" />
          <Typography variant="caption" size="sm" className="al-text-xs al-mb-0 al-text-primary">
            STG
          </Typography>
        </Stack>
        <Stack align="center">
          <Typography weight="medium" className="lines-2 al-mb-0">
            {selectedTableData?.label}
          </Typography>
        </Stack>
      </div>
      <div className={classNames(styles.card, "column-section")}>
        {[
          { label: "Stage Url", value: data.stage_url },
          { label: "Stage Region", value: data.stage_region },
          { label: "Stage Type", value: data.stage_type },
          { label: "Stage Owner", value: data.stage_owner },
        ].map(({ label, value }) => (
          <Card key={label} className="al-mb-2 al-p-2">
            <Stack>
              <Typography weight="medium" size="sm" className="al-mb-0">
                {label}:
              </Typography>
              <Typography weight="regular" size="sm" className="al-mb-0">
                {value}
              </Typography>
            </Stack>
          </Card>
        ))}
      </div>
    </Stack>
  );
};

export default SnowflakeStageDetails;
